// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();

//       this.form = this.querySelector('form');
//       this.form.querySelector('[name=id]').disabled = false;
//       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//       this.submitButton = this.querySelector('[type="submit"]');
//       if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

//       this.variantIdMap = {
//         'Short': '42990588330072',          // Твои реальные variant_id
//         'Standard': '42990588297304',
//         'Adjustable long': '42990588362840'
//       };

//       // Отслеживаем выбор варианта "2-Pack"
//       this.variantRadios = document.querySelectorAll('input[name="Packs"]');
//       this.accessoryBlock = document.getElementById('custom-packs-two-add');
//       this.variantRadios.forEach(radio => {
//         radio.addEventListener('change', () => {
//           if (radio.checked && radio.value === '2-Pack') {
//             this.accessoryBlock?.classList.remove('hidden');
//           } else {
//             this.accessoryBlock?.classList.add('hidden');
//           }
//         });
//       });
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();

//       if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//       this.handleErrorMessage();

//       this.submitButton.setAttribute('aria-disabled', true);
//       this.submitButton.classList.add('loading');
//       this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];

//       const formData = new FormData();

//       // Основной продукт
//       const mainVariantId = this.form.querySelector('[name="id"]').value;
//       const mainQuantity = this.form.querySelector('[name="quantity"]')?.value || 1;

//       // Третий продукт из выбранного radio
//       const selectedRadioTwo = document.querySelector('#custom-packs-two-add input[type="radio"]:checked');
//       if (selectedRadioTwo) {
//         const secondVariantIdTwo = this.variantIdMap[selectedRadioTwo.value];
//         if (secondVariantIdTwo && secondVariantIdTwo !== mainVariantId) {
//           formData.append('items[][id]', secondVariantIdTwo);
//           formData.append('items[][quantity]', 1);
//         }
//       }

//       // Второй продукт из выбранного radio
//       const selectedRadio = document.querySelector('#custom-packs-add input[type="radio"]:checked');
//       if (selectedRadio) {
//         const secondVariantId = this.variantIdMap[selectedRadio.value];
//         if (secondVariantId && secondVariantId !== mainVariantId) {
//           formData.append('items[][id]', secondVariantId);
//           formData.append('items[][quantity]', 1);
//         }
//       }

//       formData.append('items[][id]', mainVariantId);
//       formData.append('items[][quantity]', mainQuantity);
      
//       // Добавляем секции для обновления корзины
//       if (this.cart) {
//         const sections = this.cart.getSectionsToRender().map(section => section.id);
//         formData.append('sections', sections);
//         formData.append('sections_url', window.location.pathname);
//         this.cart.setActiveElement(document.activeElement);
//       }

//       config.body = formData;

//       // Логируем для дебага
//       for (const pair of formData.entries()) {
//         console.log(pair[0], pair[1]);
//       }

//       fetch(routes.cart_add_url, config)
//         .then(response => {
//           if (!response.ok) {
//             throw new Error(`HTTP error! Status: ${response.status}`);
//           }
//           return response.json();
//         })
//         .then(response => {
//           if (response.status) {
//             this.handleErrorMessage(response.description);

//             const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//             if (!soldOutMessage) return;
//             this.submitButton.setAttribute('aria-disabled', true);
//             this.submitButton.querySelector('span').classList.add('hidden');
//             soldOutMessage.classList.remove('hidden');
//             this.error = true;
//             return;
//           } else if (!this.cart) {
//             window.location = window.routes.cart_url;
//             return;
//           }

//           this.error = false;
//           const quickAddModal = this.closest('quick-add-modal');
//           if (quickAddModal) {
//             document.body.addEventListener('modalClosed', () => {
//               setTimeout(() => { this.cart.renderContents(response) });
//             }, { once: true });
//             quickAddModal.hide(true);
//           } else {
//             this.cart.renderContents(response);
//           }
//         })
//         .catch(e => {
//           console.error('Ошибка при добавлении товара:', e);
//           this.handleErrorMessage('Произошла ошибка при добавлении товара в корзину.');
//         })
//         .finally(() => {
//           this.submitButton.classList.remove('loading');
//           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
//         });
//     }

//     handleErrorMessage(errorMessage = false) {
//       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//       if (!this.errorMessageWrapper) return;
//       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//       if (errorMessage) {
//         this.errorMessage.textContent = errorMessage;
//       }
//     }
//   });
// }

// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();

//       this.form = this.querySelector('form');
//       this.form.querySelector('[name=id]').disabled = false;
//       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//       this.submitButton = this.querySelector('[type="submit"]');
//       if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

//       this.variantIdMap = {
//         'Short': '42990588330072',
//         'Standard': '42990588297304',
//         'Adjustable long': '42990588362840'
//       };

//       // Отслеживаем выбор варианта "2-Pack"
//       this.variantRadios = document.querySelectorAll('input[name="Packs"]');
//       this.accessoryBlock = document.getElementById('custom-packs-two-add');
//       this.variantRadios.forEach(radio => {
//         radio.addEventListener('change', () => {
//           if (radio.checked && radio.value === '2-Pack') {
//             this.accessoryBlock?.classList.remove('hidden');
//           } else {
//             this.accessoryBlock?.classList.add('hidden');
//           }
//         });
//       });
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();

//       if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//       this.handleErrorMessage();

//       this.submitButton.setAttribute('aria-disabled', true);
//       this.submitButton.classList.add('loading');
//       this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];

//       const formData = new FormData();

//       // Основной продукт
//       const mainVariantId = this.form.querySelector('[name="id"]').value;
//       const mainQuantity = this.form.querySelector('[name="quantity"]')?.value || 1;

//       // Собираем атрибуты из выбранных опций
//       const attributes = [];



//       // Добавляем выбранный вариант из основного блока как атрибут
//       const selectedRadio = document.querySelector('#custom-packs-add input[type="radio"]:checked');
//       if (selectedRadio) {
//         attributes.push(` ${selectedRadio.value}`);
//       }

//       // Добавляем выбранный вариант из "2-Pack" как атрибут
//       const selectedRadioTwo = document.querySelector('#custom-packs-two-add input[type="radio"]:checked');
//       if (selectedRadioTwo) {
//         attributes.push(` ${selectedRadioTwo.value}`);
//       }

//       // Добавляем основной товар с атрибутами
//       formData.append('items[0][id]', mainVariantId);
//       formData.append('items[0][quantity]', mainQuantity);
      
//       // Добавляем атрибуты, если они есть
//       if (attributes.length > 0) {
//         formData.append('items[0][properties][Brackets]', attributes.join(', '));
//       }

//       // Добавляем секции для обновления корзины
//       if (this.cart) {
//         const sections = this.cart.getSectionsToRender().map(section => section.id);
//         formData.append('sections', sections);
//         formData.append('sections_url', window.location.pathname);
//         this.cart.setActiveElement(document.activeElement);
//       }

//       config.body = formData;

//       // Логируем для дебага
//       for (const pair of formData.entries()) {
//         console.log(pair[0], pair[1]);
//       }

//       fetch(routes.cart_add_url, config)
//         .then(response => {
//           if (!response.ok) {
//             throw new Error(`HTTP error! Status: ${response.status}`);
//           }
//           return response.json();
//         })
//         .then(response => {
//           if (response.status) {
//             this.handleErrorMessage(response.description);

//             const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//             if (!soldOutMessage) return;
//             this.submitButton.setAttribute('aria-disabled', true);
//             this.submitButton.querySelector('span').classList.add('hidden');
//             soldOutMessage.classList.remove('hidden');
//             this.error = true;
//             return;
//           } else if (!this.cart) {
//             window.location = window.routes.cart_url;
//             return;
//           }

//           this.error = false;
//           const quickAddModal = this.closest('quick-add-modal');
//           if (quickAddModal) {
//             document.body.addEventListener('modalClosed', () => {
//               setTimeout(() => { this.cart.renderContents(response) });
//             }, { once: true });
//             quickAddModal.hide(true);
//           } else {
//             this.cart.renderContents(response);
//           }
//         })
//         .catch(e => {
//           console.error('Ошибка при добавлении товара:', e);
//           this.handleErrorMessage('Произошла ошибка при добавлении товара в корзину.');
//         })
//         .finally(() => {
//           this.submitButton.classList.remove('loading');
//           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
//         });
//     }

//     handleErrorMessage(errorMessage = false) {
//       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//       if (!this.errorMessageWrapper) return;
//       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//       if (errorMessage) {
//         this.errorMessage.textContent = errorMessage;
//       }
//     }
//   });
// }

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.variantIdMap = {
        'Short': '42990588330072',
        'Standard': '42990588297304',
        'Adjustable long': '42990588362840'
      };

      // Отслеживаем выбор варианта "2-Pack"
      this.variantRadios = document.querySelectorAll('input[name="Packs"]');
      this.accessoryBlock = document.getElementById('custom-packs-two-add');
      this.variantRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          if (radio.checked && radio.value === '2-Pack') {
            this.accessoryBlock?.classList.remove('hidden');
          } else {
            this.accessoryBlock?.classList.add('hidden');
            this.accessoryBlock?.querySelectorAll('input').forEach((el)=>{
              el.checked = false
            })
          }
        });
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();

      const bundleId = `bundle-${Date.now()}-${Math.floor(Math.random() * 1000)}`;


      // Основной продукт
      const mainVariantId = this.form.querySelector('[name="id"]').value;
      const mainQuantity = parseInt(document.querySelector('[name="quantity"]')?.value || 1, 10);

      // Собираем атрибуты из выбранных опций
      const attributes = [];

      // Флаг и счётчик для Adjustable long
      let adjustableLongCount = 0;

      // Добавляем выбранный вариант из основного блока как атрибут
      const selectedRadio = document.querySelector('#custom-packs-add input[type="radio"]:checked');
      if (selectedRadio) {
        attributes.push(` ${selectedRadio.value}`);
        if (selectedRadio.value === 'Adjustable long') {
          adjustableLongCount++;
        }
      }

      // Добавляем выбранный вариант из "2-Pack" как атрибут
      const selectedRadioTwo = document.querySelector('#custom-packs-two-add input[type="radio"]:checked');
      if (selectedRadioTwo) {
        attributes.push(` ${selectedRadioTwo.value}`);
        if (selectedRadioTwo.value === 'Adjustable long') {
          adjustableLongCount++;
        }
      }

      // Добавляем дополнительный товар, если выбран Adjustable long
      if (adjustableLongCount > 0) {
        const extraProductId = '43011074719832';
        const extraQuantity = adjustableLongCount * mainQuantity;

        formData.append('items[1][id]', extraProductId);
        formData.append('items[1][quantity]', extraQuantity);
        formData.append('items[1][properties][Bundle ID]', bundleId);
        formData.append('items[1][properties][Linked]', 'true');
      }

      // Добавляем основной товар с атрибутами
      formData.append('items[0][id]', mainVariantId);
      formData.append('items[0][quantity]', mainQuantity);
      formData.append('items[0][properties][Bundle ID]', bundleId);
      if (attributes.length > 0) {
        formData.append('items[0][properties][Brackets]', attributes.join(', '));
      }

      

      // Добавляем секции для обновления корзины
      if (this.cart) {
        const sections = this.cart.getSectionsToRender().map(section => section.id);
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      // Логируем для дебага
      for (const pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      fetch(routes.cart_add_url, config)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch(e => {
          console.error('Ошибка при добавлении товара:', e);
          this.handleErrorMessage('Произошла ошибка при добавлении товара в корзину.');
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
